import React from 'react';
import DropdownComponent from '../../../../components/dropdown';
import './style.css'
//import userThumbnail from '../../../../user.png';
const images = require("../../../../images.json");
const userThumbnail = images.user

export default class HeaderComponent extends React.Component {
    menu = [
        {
            text: "Cambiar foto",
            isRoute: true,
        },
        {
            divider: true,
        },
        {
            text: "Salir",
            onClick: this.props.logout
        }
    ]

    get userImage() {
        if(this.props.user.image)
            return this.props.user.image;
        else
            return userThumbnail;
    }

    render() {
        return (
            <div className="Header">
                <div className="navbar" role="navigation">
                    <div className="navbar-brand">
                        <figure className="image is-32x32">
                            <img alt="avatar" src={this.userImage} />
                        </figure>
                        <div className="navbar-item">
                            <DropdownComponent menu={this.menu} caret title={this.props.user.userName} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/components/header/index.js